export default "__VITE_ASSET__P10T5v0i__"